import { Box, Container, Typography } from "@mui/material";
import FooterSr from "../components/Footersr"
import FreeDeliveryBannerSr from "../components/Freedeliverysr"
import News from "../../globalCountries/countryhomepagescomponent/News";
import { useTranslation } from "react-i18next";
const TermsandconditionsSr = () => {
  const { t } = useTranslation();

  const terms = [
    t("terms.term1"),
    t("terms.term2"),
    t("terms.term3"),
    t("terms.term4"),
    t("terms.term5"),
    t("terms.term6"),
    t("terms.term7"),
    t("terms.term8"),
    t("terms.term9"),
    t("terms.term10"),
    t("terms.term11"),
    t("terms.term12"),
    t("terms.term13"),
    t("terms.term14"),
    t("terms.term15"),
    t("terms.term16"),
    t("terms.term17"),
    t("terms.term18"),
    t("terms.term19"),
  ];
  const styles = {
    heroContainer: {
      width: "100%",
      // height: {
      //   xs: getResponsiveSize(250),
      //   md: getResponsiveSize(300),
      // },
      height: { sm: "500px", xs: "400px" },
      position: "relative",
      overflow: "hidden",
    },
    heroImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 1,
    },
    heroContent: {
      // position: "relative",
      // zIndex: 2,
      height: "100%",
      display: "flex",
      alignItems: {
        sm: "center",
        xs: "end",
      },
      justifyContent: "end",
      px: 2,
      maxWidth: "1300px",
    },
    heroTitle: {
      fontFamily: "AllRoundGothicBold",
      fontWeight: 400,
      lineHeight: "60px",
      letterSpacing: "1%",
      textTransform: "uppercase",
      fontSize: {
        md: "55px",
        sm: "36px",
        xs: "30px",
      },
      zIndex: 3,
      py: 4,
      // width: {
      //   xs: "90%",
      //   md: "600px",
      // },
      // height: {
      //   xs: "auto",
      //   md: "70px",
      // },
      // position: "absolute",
      // top: {
      //   xs: "90px",
      //   md: "130px",
      // },
      // left: {
      //   xs: "auto",
      //   sm: "auto",
      //   md: "auto",
      // },
      // right: {
      //   xs: "20px",
      //   sm: "20px",
      //   md: "250px",
      // },
      // textAlign: {
      //   xs: "right",
      //   sm: "right",
      //   md: "right",
      // },
      color: "#174C2E",
      // fontSize: {
      //   xs: getResponsiveSize(30),
      //   md: getResponsiveSize(34),
      //   lg: getResponsiveSize(40),
      // },
    },
  };

  return (
    <Box>
      <Box sx={styles.heroContainer}>
        <Box
          component="img"
          src={`${process.env.REACT_APP_IMAGE_BASE_URL}termsandconditions_banner.svg`}
          alt="Terms and Conditions"
          sx={styles.heroImage}
        />
        <Container
          maxWidth="1200px"
          sx={{ height: "100%", position: "relative" }}
        >
          <Box sx={styles.heroContent}>
            <Typography sx={styles.heroTitle}>{t("terms.title")}</Typography>
          </Box>
        </Container>
      </Box>

      {/* Terms Content */}
      <Container>
        <Box
          sx={{
            // width: { xs: "100%", sm: "96%", md: "80%", lg: "66%" },
            // paddingX: { xs: 2, sm: 4, md: 0 },
            // margin: "auto", // Center the content
            // paddingY: { xs: "2px", sm: "6px", md: "10px" },
            fontFamily: "'Poppins'",
            fontWeight: 400,
             fontSize: {sm:"20px",xs:"16px"},
            lineHeight: "30px",
            letterSpacing: "0%",
            textAlign: "justify",
            color: "#4d4d4d",
            width: "100%",
            maxWidth: "1200px",
            mx: "auto",
            mt: 8,
            py: 4,
            px: {
              xs: 1,
              sm: 0,
            },
          }}
        >
          {/* <Typography
            sx={{
              color: globalStyles.colors.army_green,
              fontWeight: 600,
              // fontSize: {
              //   xs: getResponsiveSize(20),
              //   sm: getResponsiveSize(22),
              //   md: getResponsiveSize(24),
              // },
              fontSize: "24px",
              fontFamily: ' "Poppins", serif ',
              lineHeight: "32px",
              letterSpacing: "0%",
              my: {
                xs: getResponsiveHeight(2),
                sm: getResponsiveHeight(3),
                md: getResponsiveHeight(4),
              },
            }}
          >
            {t("terms.heading")}
          </Typography> */}

          <ol type="1" className="list-decimal sm:pl-8 pl-4 m-0">
            {terms.map((term, index) => (
              <li key={index}>
                <Typography
                  component="span"
                  sx={{
                    fontFamily: "'Poppins'",
                    fontWeight: 400,
                    fontSize: {sm:"20px",xs:"16px"},
                    lineHeight: "30px",
                    letterSpacing: "0%",
                    textAlign: "justify",
                    color: "#4d4d4d",
                  }}
                >
                  {term}
                </Typography>
              </li>
            ))}
          </ol>
        </Box>
        <hr className="pb-8" />
      </Container>
    <FreeDeliveryBannerSr/>
      <News />
     <FooterSr/>
    </Box>
  );
};

export default TermsandconditionsSr;
